<template>
  <div>
    <single-product />
  </div>
</template>

<script>
import SingleProduct from '@/components/SingleProduct.vue';
export default {
  name: 'ProductDetails',
  components: { SingleProduct },
}
</script>

<style scoped>
</style>

